import React from "react";
import "../../styles/requestConfirmed.css";
import { createBrowserHistory as createHistory } from 'history'
const history = createHistory()
export default class ArtworkNotAvailable extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            toArtworks: false
        }
    }

    componentDidMount() {
        // this.backListener = history.listen(location => {
        //     // if (location.hash === "#/onboardingone") {
        //     // Do your stuff
        //     console.log("popping", location)
        //     window.history.go(-1)
        //     // }
        // });
    }
    handleArtworkClick() {
        this.setState({
            toArtworks: true
        })
    }
    render() {
        if (this.state.toArtworks) {
            return (
                <redirect push to="/artworks" />
            )
        }
        return (
            <div className="col-sm-12 background-grey">
                <article className="post-88 page type-page status-publish hentry">
                    <div className="woocommerce">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <div className="heading-welcome_">
                                    ARTWORK NOT AVAILABLE
                                    <hr className="line-category-name margin-auto"></hr>
                                </div>
                            </div>
                            <div className="col-sm-6 UploadPaintingCard text-center ">

                                <div className="d-flex justify-content-center mt-25 pt-25">
                                    <div className="rectangle-block">
                                        <div className="rectangle-out">
                                            <div className="rectangle-in">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-center">
                                    <div className="empty-canvas-text not-avail">
                                        The artwork is not available at the moment, it might be temporarily unavilable
                                        or the link has expired.
                                    </div>
                                </div>



                                <a href="/artworks">

                                    <button
                                        // onClick={this.handleArtworkClick.bind(this)}
                                        className="masterpieces-primary-buttons btn-primary height-48 p-35 mb-25">
                                        BROWSE OTHER ARTWORKS
                                         </button>
                                </a>

                            </div>

                        </div>

                    </div>
                </article>
            </div>

        )
    }
}


// WEBPACK FOOTER //
// ./src/components/products/artwork-not-available.js